import { useEffect, useState } from 'react';

import { isAndroidOS, isAppleOS, isMacOS } from '@telialt/utils/src/helpers';

type DevicePlatform = 'apple' | 'android' | 'other' | null;
export const useDevicePlatform = () => {
    const [platform, setPlatform] = useState<DevicePlatform>(null);

    useEffect(() => {
        if (isAppleOS() || isMacOS()) {
            setPlatform('apple');
        } else if (isAndroidOS()) {
            setPlatform('android');
        } else {
            setPlatform('other');
        }
    }, []);

    return platform;
};
